import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class PaginatorService {
  /**
   * Client
   */
  private _paginatorModel = new ReplaySubject<Array<SimplePaginator>>(1);

  constructor() {}

  /**
   * Paginator Model
   */
  get paginatorModel(): Observable<Array<SimplePaginator>> {
    return this._paginatorModel.asObservable();
  }

  setPaginatorModel(obj: Array<SimplePaginator>): void {
    this._paginatorModel.next(obj);
  }

  get pageSizeOptions(): Array<number> {
    return [30, 60, 100];
  }
}

export interface SimplePaginator {
  modelName: string;
  pageIndex: number;
  pageSize: number;
}
